<template>
  <div class="advocate"  v-on:scroll="handleScroll(event)" style="  overflow: hidden;">
      <div id="label"><h1 id="labeltext">熱銷建案</h1><hr id="labelhr"></div>
        <div class="about-photos">
          <div class="photo-container">
            <img v-show="carouselId == pic.id"
                :src="require(`@/assets/carousel2x/${pic.photo}@2x.png`)"
                class="photo" v-for="pic in carousel" :key="pic.id">
          </div>
            <span class="photo-text" v-show="carouselId == pic.id"
              v-for="pic in carousel" :key="pic.id">{{pic.description}}</span>
                <div class="dot-container">             
                  <span v-for="pic in carousel" @click="changecarousel(pic)"
                        :key="pic.id" :class="{dots: carouselId !== pic.id, dotsactive : carouselId == pic.id}"></span>
                </div>              
        </div>
      <div id="sublabel"><hr id="sublabelhr"><h1 id="sublabeltext">最新推案</h1></div>  
        <div class="bestseller">
          <div class="bestsellerphoto">
            <router-link to="/advocate/mobilegoldenWorld">
            <img src="./../assets/world/world.jpg"
                id="sIntegrity" class="insidephoto"></router-link>             
          </div>
          <div class="bestsellerphoto">       
            <router-link to="/advocate/mobilegoldenDragon">
            <img src="./../assets/dragon/dragon-.jpg"
                id="sprime" class="insidephoto"></router-link> 
          </div>
          <div class="bestsellerphoto">   
            <router-link to="/advocate/mobilegoldenBig">
            <img src="./../assets/big/big-.jpg"
                id="slv" class="insidephoto"></router-link>
          </div>
          <div class="bestsellerphoto"> 
            <router-link to="/advocate/mobilegoldenBerkley">
            <img src="./../assets/berkley/berkley-.jpg"
                id="splus" class="insidephoto"></router-link>               
          </div>
        </div>
      <div :id="this.third+'rdlabel'"><h1 :id="this.third+'rdlabeltext'">歷年建案</h1><hr :id="this.third+'rdlabelhr'"></div>      
      <div class="previouswork">
        <div class="tabletitle">
          <div class="td1">時間</div> 
          <div class="td2">案名</div> 
          <div class="td3">地點</div>           
        </div>
          <div class="tablecontent" v-for="work in allworks" :key="work.date" v-show="autoplayId == work.id">
            <div class="tr1">{{work.date}}</div>
            <div class="tr2">{{work.title}}</div>
            <div class="tr3">{{work.address}}</div>
          </div>  
      </div>
          <img v-show="autoplayId == photo.id"
                 :src="require(`@/assets/previouswork/${photo.photo}.png`)"
                class="nowshownphoto" v-for="photo in allworkphotos" :key="photo.id">     
        <div class="dot-container">             
          <span v-for="photo in allworkphotos" @click="changeautoplay(photo)"
                :key="photo.id" :class="{dots: autoplayId !== photo.id, dotsactive : autoplayId == photo.id}"></span>
        </div> 
    <!-- <mobilefoot/>       -->
  </div>
  
</template>
 
<script>
import mobilefoot from './../components/mobilefoot.vue'
export default {
  components:{
    mobilefoot
  },
  data(){
    return {     
      third:'',
      carouselId: 1,
      carousel:[
        // {id:0,description:'金石站前湛',photo:'goldFront'},
        {id:1,description:'金石成大砌',photo:'big'},
        {id:2,description:'金石世築',photo:'world'},
        {id:3,description:'金石龍悅',photo:'dragon1'},
        {id:4,description:'金石喆學',photo:'gold_inte'},
        {id:5,description:'金石雙響',photo:'gold_db'},
        {id:6,description:'金石首品',photo:'gold_prime'},
        {id:7,description:'金石首品II',photo:'gold_ii'},
        {id:8,description:'金石首品II',photo:'gold_ll'},
        {id:9,description:'金石LV',photo:'gold_lv'},
        {id:10,description:'金石PLUS',photo:'gold_plus'},

      ],
      autoplayId:1,
      allworks:[
        {id:1,date:'1985.06',title:'金石興嘉花園城',address:'興嘉'},
        {id:1,date:'1985.11',title:'金石法蘭克別墅',address:'仁義國宅旁'},
        {id:1,date:'1986.03',title:'金石雙功能別墅',address:'竹圍'},
        {id:1,date:'1987.12',title:'金石友愛商城',address:'友愛路'},
        {id:1,date:'1988.08',title:'金石名園',address:'青年街'},
        {id:1,date:'1989.10',title:'金石花園別墅',address:'台林街'},

        {id:2,date:'1990.04',title:'金石港坪花園別墅',address:'港坪'},
        {id:2,date:'1990.12',title:'金龍書苑名廈',address:'崇文街'},
        {id:2,date:'1991.05',title:'金玉滿堂花園別墅',address:'灣橋'},
        {id:2,date:'1992.07',title:'金玉滿堂雙功能名店',address:'後壁'},
        {id:2,date:'1993.09',title:'金慶花園名廈NO.1',address:'文化路'},
        {id:2,date:'1994.02',title:'金慶花園名廈NO.2',address:'八德路'},
        {id:2,date:'1994.03',title:'金慶花園名廈NO.3',address:'八德路'},

        {id:3,date:'1995.03',title:'金慶世貿花園名廈',address:'世貿路'},
        {id:3,date:'1996.06',title:'金石金城NO.1',address:'向榮街'},
        {id:3,date:'1997.11',title:'金石金城NO.2',address:'新榮路'},
        {id:3,date:'1998.10',title:'金石名園',address:'北鎮街'},
        {id:3,date:'1999.08',title:'金石商業區',address:'南京路'},
        {id:3,date:'2000.09',title:'金石維多利亞',address:'嘉工街'},

        {id:4,date:'2001.03',title:'金石三多利',address:'保健街'},
        {id:4,date:'2002.08',title:'金石文化花園別墅',address:'大業街'},
        {id:4,date:'2003.07',title:'金石都會別墅',address:'文化路'},
        {id:4,date:'2003.09',title:'金石學府花園別墅',address:'大業街'},
        {id:4,date:'2004.06',title:'金石皇家帝國',address:'台林街'},
        {id:4,date:'2005.05',title:'金石金站',address:'西榮街'},

        {id:5,date:'2007.03',title:'金石金店',address:'民權路'},
        {id:5,date:'2007.09',title:'金石王朝',address:'興達路'},
        {id:5,date:'2010.03',title:'金石皇家特區',address:'友愛路'},
        {id:5,date:'2011.03',title:'金石皇家特區NO.2',address:'保安二路'},
        {id:5,date:'2013.03',title:'金石ＶＩＰ',address:'灣橋'},
        {id:5,date:'2014.10',title:'金石ＬＶ',address:'保安一路'},

        {id:6,date:'2015.10',title:'金石＋ＰＬＵＳ',address:'興達路'},
        {id:6,date:'2017.02',title:'金石首品',address:'通化二街'},
        {id:6,date:'2018.02',title:'金石首品II',address:'玉康路'},
        {id:6,date:'2018.05',title:'金石雙響',address:'友愛路'},
        {id:6,date:'2019.03',title:'金石喆學',address:'雙園街'},
        {id:6,date:'2020.01',title:'金石乒乓球館',address:'友忠路'},
        
        {id:7,date:'2020.03',title:'金石龍悅',address:'新民路 '},
        {id:7,date:'2020.08',title:'金石世築',address:'四維路'},
        {id:7,date:'2020.11',title:'金石鉑克萊',address:'立仁路'},
        {id:7,date:'2021.04',title:'金石成大砌',address:'博愛路'},

      ],
      allworkphotos:[
        {id:1, photo:'p1'},
        {id:2, photo:'p2'},
        {id:3, photo:'p3'},
        {id:4, photo:'p4'},
        {id:5, photo:'p5'},
        {id:6, photo:'p6'},
        {id:7, photo:'p7'},
      ]
      }
  },
  methods: {
      handleScroll (event) {
        this.windowscrollY = window.scrollY
        // console.log(this.windowscrollY)
        if (this.windowscrollY > 170) {
            this.third = 'thi'
        }        

      // else console.log('no')
      },
      changecarousel(pic){
        this.carouselId = pic.id
        //console.log(this.carouselId)
      },
      runningcarousel(){
          this.carouselId = this.carouselId + 1 
          if(this.carouselId== 8){
            this.carouselId = 1
          }
      },
      changeautoplay(photo){
        this.autoplayId = photo.id
        //console.log(this.autoplayId)
      },
      runningautoplay(){
          this.autoplayId = this.autoplayId + 1 
          if(this.autoplayId== 7){
            this.autoplayId = 1
          }
      },
  },
  created () {
      window.addEventListener('scroll', this.handleScroll);
      this.interval = setInterval(() => this.runningcarousel(), 6500);
      this.interval = setInterval(() => this.runningautoplay(), 10000);
  },
  destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped>
.advocate{
  width: 100%;
  height: auto;
  margin: 80px 0 15% 0;
}

#label {
  margin: 0 0;
  width:  100%;
  height: 60px;
}
@keyframes show-draw{
    100% {
        opacity: 1;
        }
    }
#labeltext {
  margin: auto 0 auto 6%;
  float: left;
  width:  24%;
  height: 20px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.71px;
  color: #a89a80;
  opacity: 0;
  animation: show-draw 0.6s linear forwards;
  -webkit-animation: show-draw 0.6s linear forwards;
  animation-delay: 0.8s;
	-webkit-animation-delay: 0.8s;
}
@keyframes show-draw-hr{
    100% {
        /* width: 82%; */
        transform-origin: left top;
        width: 68%;
        }
    }
#labelhr {
  margin: 15px 0;
  float: right;
  width: 2%;
  border: solid 0.5px #d0ad76;
  animation: show-draw-hr 0.9s ease-out forwards;
  -webkit-animation: show-draw-hr 0.9s ease-out forwards;
  animation-delay: 0s;
	-webkit-animation-delay: 0s;
}

@keyframes showtext{
    100% {
      opacity: 1;
      transform: translateY(4px);
        }
    }
.about-photos{
  width: 100%;
  height: auto;
  margin: 3% 0 10% 0;
  text-align: center;
  /* background-image: linear-gradient(320deg, #c4c3c283, #dadad9 3%, #ebebeb 18%, #feffffa2, #ffffff); */
}
.photo-container{
  width: 100%;
  height: auto;
  overflow:hidden;
}
@keyframes showupfoto{
  0%{opacity: 0.75}
  80%{opacity: 0.85}
  100%{opacity: 0.7}
}
.photo{
  width: 100%;
  height: 235px;
  /* object-fit: contain; */
  opacity: 0.75;
  margin-right: 50px;
  animation: showupfoto 6.5s ease-out forwards;
  -webkit-animation: showupfoto 6.5s ease-out forwards;
}
.photo:hover{  
  opacity: 1.0 !important; }

.photo-text{
  text-align: center;
  width: 100%;
  margin: 1% auto;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.32px;
  color: #8f8f8f;
}
.dot-container{ 
  height:auto; width:100%;
  margin: 0% auto;
  text-align: center;
  vertical-align:middle;
  }
.dots{
  display: inline-block;
  padding: 2px;
  margin: 0% 3%;
  border-radius: 50%;
  border: solid 1px #d8d8d8;
  background-color: #d8d8d8;
}
.dotsactive{
  display: inline-block;
  padding: 2px;
  margin: 0% 3%;
  border-radius: 50%;
  background: #d0ad76;
  border: 1px solid #d0ad76;
}
.dots:hover, .dotsactive:hover{cursor: pointer;}

#sublabel {
  margin: 0 0;
  width:  100%;
  height: 60px;
}
#sublabeltext {
  margin: auto 2% auto 0;
  float: right;
  width:  24%;
  height: 20px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.71px;
  color: #a89a80;
  opacity: 0;
  animation: show-draw 0.6s linear forwards;
  -webkit-animation: show-draw 0.6s linear forwards;
  animation-delay: 1.8s;
	-webkit-animation-delay: 1.8s;
}
@keyframes show-draw-hr{
    100% {
        /* width: 82%; */
        transform-origin: left top;
        width: 68%;
        }
    }
#sublabelhr {
  margin: 15px 0;
  float: left;
  width: 2%;
  border: solid 0.5px #d0ad76;
  animation: show-draw-hr 0.9s ease-out forwards;
  -webkit-animation: show-draw-hr 0.9s ease-out forwards;
  animation-delay: 1s;
	-webkit-animation-delay: 1s;
}
.bestseller{
  margin: 1% auto;
  height: auto;
  width: 92%;
}
.bestsellerphoto{
  margin: 0.3% 2% 0.1% 2%;
  width: 158px;
  height: 94px;
  display: inline-block;
  overflow: hidden;
}
.insidephoto{
  width: 158px;
  height: 94px;
  opacity: 0.8;
}

@keyframes popover{
  0%{  transform: scale(1);  opacity: 0.8;}
  100%{  transform: scale(1.2);   opacity: 1;}
}
.insidephoto:hover{
  animation: popover 0.6s ease-in forwards;
  -webkit-animation: popover 0.6s ease-in forwards;
  opacity: 1;
}
.insidephoto:active{
  animation: popover 0.6s ease-in forwards;
  -webkit-animation: popover 0.6s ease-in forwards;
  opacity: 1;
}

#rdlabel {
  margin: 9% 0 5% 0;
  width:  100%;
  height: 60px;
  opacity: 0;
}
#thirdlabel {
  margin: 9% 0 5% 0;
  width:  100%;
  height: 60px;
}
#thirdlabeltext {
  margin: auto 0 auto 6%;
  float: left;
  width:  24%;
  height: 20px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.71px;
  color: #a89a80;
  opacity: 0;
  animation: show-draw 0.6s linear forwards;
  -webkit-animation: show-draw 0.6s linear forwards;
  animation-delay: 1.8s;
	-webkit-animation-delay: 1.8s;
}
#thirdlabelhr {
  margin: 15px 0;
  float: right;
  width: 2%;
  border: solid 0.5px #d0ad76;
  animation: show-draw-hr 0.9s ease-out forwards;
  -webkit-animation: show-draw-hr 0.9s ease-out forwards;
  animation-delay: 0s;
	-webkit-animation-delay: 0s;
}

 .previouswork{
  width: 100%;
  margin: 5% auto;
  font-family: PingFangTC;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 1.18px;
  color: #a7a7a7;
}
.previouswork .tabletitle{    font-size: 13px; width: 100%; margin: 4% auto;}
.tabletitle > .td1{ width:100px; padding: 1% 2% 1% 1%;text-align: center; display: inline-block;}
.tabletitle > .td2{ width:150px; padding: 1% 2% 1% 1%;text-align: center;display: inline-block;}
.tabletitle > .td3{ width:70px; padding: 1% 3% 1% 0%;text-align: center;display: inline-block;}
.previouswork .tablecontent{ width: 100%; margin: auto auto;}
.tr1,.tr2{ border-right: solid 0.5px #979797c2;}
.tablecontent > .tr1{ width:80px; padding: 2% 0% 2% 6%;text-align: left; display: inline-block;}
.tablecontent > .tr2{ width:152px; padding: 2% 0% 2% 4.5%;text-align: left;display: inline-block;}
.tablecontent > .tr3{ width:76px; padding: 2% 0% 2% 4.5%;text-align: left;display: inline-block;}

.nowshownphoto{
  width: 100%;
}
</style>